import { Box } from '@mui/material';
import { FC } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import EditCompanyAddress from 'components/EditCompany/EditCompanyAddress';
import EditCompanyDescription from 'components/EditCompany/EditCompanyDescription';
import EditCompanyName from 'components/EditCompany/EditCompanyName';
import EditCompanyPhoneNumber from 'components/EditCompany/EditCompanyPhoneNumber';

import { useMyCompanyDetailsQuery, useUpdateMyCompanyMutation } from '../../../../graphql/generated/hooks';

const MyCompanyDetailsPage: FC = () => {
  const { t } = useTranslation('translation');

  const { data, loading } = useMyCompanyDetailsQuery();

  const [updateMyCompany] = useUpdateMyCompanyMutation({
    errorPolicy: 'all',
    update(_, { data }) {
      if (data) {
        toast.success(t('messages.success.company-description-updated'));
      }
    },
  });

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <EditCompanyName data={data?.me} loading={loading} mutation={updateMyCompany} />
      <EditCompanyAddress data={data?.me} loading={loading} mutation={updateMyCompany} />
      <EditCompanyPhoneNumber data={data?.me} loading={loading} mutation={updateMyCompany} />
      <EditCompanyDescription data={data?.me} loading={loading} mutation={updateMyCompany} />
    </Box>
  );
};

export default MyCompanyDetailsPage;
